;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useFlags } from 'launchdarkly-react-client-sdk'

export const useIsShipWithQogitaOutageBannerVisible = () => {
  const flags = useFlags()
  return Boolean(flags.sellersShipWithQogitaOutageBannerVisible)
}

export const useIsPotentialSuppliersActingOnBuyerRequestsEnabled = () => {
  const flags = useFlags()
  return Boolean(flags.enablePotentialSuppliersActingOnBuyerRequests)
}
